import { UsageLimitsResponse } from "../../../types/user";

export const getStoragePct = (usage: UsageLimitsResponse | null) =>
  usage ? (usage.storage_used_gb / usage.storage_limit_gb) * 100 : 0;

export const getTranscriptPct = (usage: UsageLimitsResponse | null) =>
  usage ? (usage.transcript_hours_this_month / usage.transcript_limit_hours) * 100 : 0;

export const getExportsPct = (usage: UsageLimitsResponse | null) =>
  usage ? (usage.exports_count_this_month / usage.exports_limit) * 100 : 0;

export const getStorageLabel = (usage: UsageLimitsResponse | null) =>
  usage ? `${usage.storage_used_gb} GB / ${usage.storage_limit_gb} GB` : "—";

export const getTranscriptLabel = (usage: UsageLimitsResponse | null) =>
  usage ? `${usage.transcript_hours_this_month} hrs / ${usage.transcript_limit_hours} hrs` : "—";

export const getExportsLabel = (usage: UsageLimitsResponse | null) =>
  usage ? `${usage.exports_count_this_month} / ${usage.exports_limit}` : "—";
